import styled, { css } from 'styled-components';
import { breakpoints, spacing } from '@chegg-ui/theme';

export const AuthPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: ${breakpoints.lg.max};
  margin: 0 auto;
  min-height: calc(100vh - 224px);
`;

const baseAd = css`
  overflow: hidden;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: auto;
`;

export const CheggStudyBackground = styled.div`
  ${baseAd};
  background: url('https://c.cheggcdn.com/assets/site/images/authscreen-cs.jpg') no-repeat center
    center/cover;
`;

export const CheggMathBackground = styled.div`
  ${baseAd};
  background: url('https://c.cheggcdn.com/assets/site/images/img-math-signin-background-2.jpg')
    no-repeat center center/cover;
`;

export const OneAuthContainer = styled.div`
  margin: 0;
  display: flex;
  height: max-content;

  @media only screen and (min-width: ${breakpoints.sm.min}) and (max-width: ${breakpoints.sm.max}) {
    flex-direction: column-reverse;
    width: 100vw;
  }
  @media only screen and (min-width: ${breakpoints.md.min}) and (max-width: ${breakpoints.md.max}) {
    margin: ${spacing.px48} auto;
    flex-direction: column-reverse;
    }
  }
  
  @media only screen and (min-width: ${breakpoints.lg.min}) and (max-width: ${breakpoints.lg.max}) {
    margin: ${spacing.px48} ${spacing.px24};
    &.simplifiedstudy,
    &.pla,
    &.uversity {
      margin: ${spacing.px48} auto;
    }
  }
  @media only screen and (min-width: ${breakpoints.xl.min}) and (max-width: ${breakpoints.xl.max}) {
    margin: ${spacing.px48} ${spacing.px24};
    &.simplifiedstudy,
    &.pla,
    &.uversity {
      margin: ${spacing.px48} auto;
      gap: ${spacing.px80};
    }
  }
`;
